<template>
    <div class="app-header-placeholder"></div>
    <header ref="header" class="app-header" :class="{small}">
        <header-black-header></header-black-header>
        <section class="inner-body-block main-header">
            <nuxt-link to="/">
                <img class="logo" src="~/assets/icons/header/logo.svg" alt="Трия">
            </nuxt-link>

            <header-top-menu></header-top-menu>

            <header-search></header-search>

            <div class="icon-buttons">
                <nuxt-link class="header-icon" to="/personal/favorites/">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path stroke="#08091c" stroke-linecap="round" stroke-linejoin="round" d="M2.667 12.667a7.333 7.333 0 0 1 12.788-4.901.746.746 0 0 0 1.09 0 7.32 7.32 0 0 1 12.789 4.901c0 3.054-2 5.334-4 7.334l-7.323 7.084a2.668 2.668 0 0 1-4 .025L6.667 20c-2-2-4-4.266-4-7.333"/></svg>
                    <div class="badge" v-if="favoriteStore.count">{{favoriteStore.count}}</div>
                </nuxt-link>
                <nuxt-link to="/personal/cart/" rel="nofollow" class="header-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path stroke="#08091c" stroke-linecap="round" stroke-linejoin="round" d="M2.733 2.734h2.666l3.547 16.56a2.666 2.666 0 0 0 2.667 2.107h13.04a2.67 2.67 0 0 0 2.6-2.093l2.2-9.907H6.826M12 28.001a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.666 0m14.666 0a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0"/></svg>
                    <div class="badge" v-if="cartStore.cartItemsCount">{{ cartStore.cartItemsCount }}</div>
                </nuxt-link>
            </div>
        </section>
        <section class="inner-body-block menu">
            <nuxt-link class="btn round" v-for="item of menuStore.headerMenu" :class="item.style" :to="item.href">{{ item.title }}</nuxt-link>
        </section>
        
    </header>
<div id="main-menu-target"></div>
    <div id="flash-target"></div>

    <client-only>
        <header-flash></header-flash>
    </client-only>
</template>

<script lang="ts" setup>
import { useResizeObserver } from "@vueuse/core";
import { useFavoriteStore } from "~/store/favoriteState";
import { useMenuStore } from "~/store/menuState";
import { useCartStore } from "~~/store/cartStore";

const menuStore = useMenuStore();
const cartStore = useCartStore();
const favoriteStore = useFavoriteStore();

const headerElement = useTemplateRef("header");

const small = ref(false);

onMounted(() => {
    if (!headerElement.value) {
        return;
    }

    const target = headerElement.value;

    let rect: DOMRectReadOnly = target.getBoundingClientRect();

    let headerPosition = Math.max(0, window.scrollY - rect.height);
    let lastPosition = window.scrollY;
    target.style.top = `${headerPosition}px`;

    document.addEventListener('scroll', () => {

        const scroll = Math.max(window.scrollY, 0);

        small.value = scroll > 240;

        const top = Math.max(rect.height - Math.max(scroll - headerPosition, 0), 0);
        document.documentElement.style.setProperty('--header-position', `${top + 1}px`);

        if (lastPosition > scroll && headerPosition + rect.height < scroll) {
            headerPosition = scroll - rect.height;
            setAbsoluteHeader(headerPosition);
            target.style.top = `${headerPosition}px`;
        } else if (headerPosition >= scroll) {
            headerPosition = scroll;
            setFixedHeader();
        } else if (lastPosition < scroll) {
            setAbsoluteHeader(headerPosition);
        }

        lastPosition = scroll;
    }, {passive: true});

    useResizeObserver(headerElement.value, (box) => {
        if (!box.length && !box[0]?.borderBoxSize.length) {
            return;
        }
        rect = box[0]!.contentRect;

        const top = Math.max(rect.height - Math.max(lastPosition - headerPosition, 0), 0);
        document.documentElement.style.setProperty('--header-position', `${top + 1}px`);
    })
});

function setFixedHeader() {
    if (headerElement.value) {
        const el = headerElement.value;
        el.style.top = '0';
        el.style.position = 'fixed';
    }
}

function setAbsoluteHeader(px: number) {
    if (headerElement.value) {
        const el = headerElement.value;
        el.style.top = `${px}px`;
        el.style.position = 'absolute';
    }
}


</script>


<style lang="scss" scoped>

@use '~/assets/css/colors.scss' as *;

$headerHeight: 190px;

.app-header-placeholder {
    height: $headerHeight;
    width: 100%;
}

.app-header {
    height: $headerHeight;
    top: 0;
    width: 100%;
    position: absolute;
    background: white;
    border-bottom: 1px solid var(--brdr0);
    overflow: hidden;
    transition: height .1s;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;

    z-index: 900;

    &.small {
        height: 110px;

        :deep(.top-header) {
            height: 28px;
        }

        .main-header {
            padding-top: 6px;
        }

        :deep(.city-selector-button img) {
            width: 15px;
        }
    }
}
.main-header {
    align-items: center;
    display: flex;
    padding-top: 12px;
    // height: 115px;
    // padding: var(--gap-size) 0;
    justify-content: space-between;
    gap: 0 50px;
    transition: padding-top .1s .05s;
}

.logo {
    height: 66px;
    width: 77px;
}

.icon-buttons {
    display: flex;
    gap: 30px;
    align-items: center;
}

.header-icon {
    position: relative;
    height: 33px;

    svg {
        // width: 47px;
        // height: 33px;
        path {
            stroke-width: 1.2;
            transition: stroke .1s;
        }
    }

    &:hover svg path {
        stroke: var(--t1);
    }

    .badge {
        background-color: var(--orange);
        color: #fff;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        top: -4px;
        right: -6px;
        min-width: 16px;
        height: 16px;
        border-radius: 8px;
        font-weight: 400;
        font-size: 12px;
    }
}

#flash-target {
    position: fixed;
    top: 30px;
    right: 30px;
    max-width: 400px;

    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 30px;
    z-index: 1050;

    &>* {
        position: relative;
        right: 0;
    }

    &>:deep(.v-enter-active) {
        transition: right .2s cubic-bezier(.2,.35,.88,1.21);
    }

    &>:deep(.v-leave-active) {
        transition: right .2s ease;
    }


    &>:deep(.v-enter-from),
    &>:deep(.v-leave-to) {
        right: var(--width, -460px);
    }
}

#main-menu-target {
    position: relative;
    z-index: 1000;
}

.menu {
    display: flex;
    gap: 20px;
    align-items: center;
    height: 34px;
    margin: 17px auto;

    a {
        color: var(--t0);
        text-decoration: none;
        transition: background-color .1s;

        &:hover,
        &:active {
            background-color: var(--bg1);
        }

        // &.orange {
        //     color: var(--orange);
        //     border: 1px solid var(--orange);
        // }
    }
}

</style>